import * as React from "react";
const SvgTrendingDown = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.6562 12L12.1875 10.4688L8.9375 7.21875L6.28125 9.875L1.34375 4.9375L2.28125 4L6.28125 8L8.9375 5.34375L13.125 9.53125L14.6562 8V12H10.6562Z",
	fill: "currentColor"
}));
export default SvgTrendingDown;
